import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.footer`
    margin: 6rem 0 1rem 0;
    font-size: 1rem;
    padding: 1rem ${props => props.theme.spacer.horizontal};
    text-align: center;
    color: ${props => props.theme.colors.grey};
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: space-evenly;
        -ms-flex-pack: space-evenly;
            justify-content: space-evenly;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding: 0;
        margin: 5rem 0 0;
        -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
                -ms-flex-direction: column;
                    flex-direction: column;
    }
            .copy {
                font-size: .8rem;
            }
    a {
        text-decoration: none;
        color: ${props => props.theme.colors.black};
        padding: 0 5px;
        font-size: .8rem;
    }
    a :hover {
        text-decoration: none;
        color: ${props => props.theme.brand.primary};
    }
    .footer__links {
        list-style-type: none;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            padding: 0;
        }
    }
    .footer__links--item {
       margin: 0 5 px;
    }
`

const Footer = () => (
     <Wrapper data-testid="footer">
        <div className="copy">
            Copyright &copy; 2019. 
            <a href="https://silviu-stefanescu.github.io/">Silviu Stefanescu</a> {' '}
        </div>
    
    <ul className="footer__links">
        <li className="footer__links--item"><a href="https://www.linkedin.com/in/silviu-stefanescu-793a2a48/" target="_blank">LinkedIn</a></li>
         <li className="footer__links--item"><a href="https://github.com/silviu-stefanescu" target="_blank">GitHub</a></li>
         <li className="footer__links--item"><a href="https://codepen.io/silviustefanecu/" target="_blank">CodePen</a></li>
         <li className="footer__links--item"><a href="https://www.upwork.com/freelancers/~0141b423214812c38e?viewMode=1" target="_blank">Upwork</a></li>
        <li className=".last-child"><a href="https://www.behance.net/silviunicolae" target="_blank">Behance</a></li>
    </ul>
  </Wrapper>
)

export default Footer
